// extracted by mini-css-extract-plugin
export var cardHeader = "_g6-0";
export var reorderHandle = "_g6-3";
export var titleArea = "_g6-1";
export var titleAreaWithHandle = "_g6-2";